module.exports = __webpack_public_path__ + "img/Sleep.2d11f461.png";